const root = document.documentElement;
root.setAttribute('data-atelea-loader-script-ready', '');
const loader = document.querySelector('.atelea-page-loader');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const loaderPreview = new URLSearchParams(window.location.search)
  .get('atelea-loader-preview') === '1';
/** @type {KeyframeAnimationOptions} */
const motion = {
  easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
  fill: 'both',
};
/** @type {Animation|null} */
let loaderAnimation = null;
let transitionSequence = 0;

function cancelLoaderAnimation() {
  transitionSequence += 1;
  loaderAnimation?.cancel();
  loaderAnimation = null;
}

/**
 * @param {Animation} animation
 * @param {number} timeout
 */
async function finishOrTimeout(animation, timeout) {
  const deadline = new Promise((resolve) => {
    window.setTimeout(() => resolve(undefined), timeout);
  });
  await Promise.race([animation.finished.catch(() => {}), deadline]);
}

async function revealPage() {
  if (root.hasAttribute('data-atelea-page-ready')) return;

  cancelLoaderAnimation();
  if (!loader || reducedMotion.matches) {
    root.setAttribute('data-atelea-page-ready', '');
    return;
  }

  const sequence = transitionSequence;
  try {
    loaderAnimation = loader.animate(
      [{ opacity: 1 }, { opacity: 0 }],
      { ...motion, duration: 320 }
    );
    await finishOrTimeout(loaderAnimation, 600);
  } catch {
    // A failed animation must not leave the page covered.
  }

  if (sequence !== transitionSequence) return;
  root.setAttribute('data-atelea-page-ready', '');
  cancelLoaderAnimation();
}

window.addEventListener('pageshow', (event) => {
  if (!event.persisted || loaderPreview) return;
  revealPage();
});

if (!loaderPreview) {
  if (document.readyState === 'complete') {
    revealPage();
  } else {
    window.addEventListener('load', revealPage, { once: true });
  }
}
